/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import mapRoutes from 'flarum/common/utils/mapRoutes';
import app from 'flarum/forum/app';

/**
 * Reloads the application content without reloading the browser location
 *
 * @param route The route to end up on once the content has been remounted
 */
export async function rerouteTo(route: string): Promise<void> {
	// route to a loading page
	m.route.set('/__loading');

	// mount the application content newly
	// `#content` is rendered by the forum layout, so it is always present when this runs.
	m.route(document.getElementById('content')!, '/', mapRoutes(app.routes, ''));

	// route to the defined route (promise)
	await new Promise<void>((resolve) => {
		setTimeout(() => {
			m.route.set(route);
			resolve();
		}, 1);
	});
}

export function rerouteToCurrent(): void {
	rerouteTo(m.route.get());
}
